<template>
  <div class="aoform__filler"></div>
</template>

<script>
export default {

}
</script>

<style lang="sass">
.aoform__filler
  flex-grow: 1
</style>